import { ChannelUpdateDraftResponse } from "../proto/ChannelUpdateDraft_pb";
import { ChatUpdateDraftResponse } from "../proto/ChatUpdateDraft_pb";
import { GroupUpdateDraftResponse } from "../proto/GroupUpdateDraft_pb";
import store from "../store";
import { setDraftText } from "../store/draft/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomUpdateDraftResponse extends BaseHandler<ChatUpdateDraftResponse | GroupUpdateDraftResponse | ChannelUpdateDraftResponse> {
  handle() {
    const roomUpdateDraftResponse = this.response.toObject();
    const roomId = roomUpdateDraftResponse.roomId;
    store.dispatch(setDraftText({ draft: { message: roomUpdateDraftResponse.draft?.message }, roomId }));
  }
}
